module.exports = __webpack_public_path__ + "static/img/ad4.5730f5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark40/ad4.png
// module id = Hq4T
// module chunks = 12